import React, { useState, useRef, useEffect } from "react";
import ReproductorMp3 from "./ReproductorMp3";
import IconoCircular from "./IconoCircular";
import CarruselHeader from "./CarruselHeader";
export default function Head({ setPagina }) {

  const [showGoUp, setShowGoUp] = useState(false);

  const goUp = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 1000) {
        setShowGoUp(true); // Mostrar el icono
      } else {
        setShowGoUp(false); // Ocultar el icono
      }
    };

    // Agregar el evento de scroll al cargar el componente
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };

  }, []);

  // Estado que gestiona si el menú está abierto o cerrado
  const [isMenuActive, setIsMenuActive] = useState(false);

  const toggleMenu = () => {
    if (window.innerWidth < 768) {
      setIsMenuActive(!isMenuActive);
    }
  };

  const cambiaPagina = (pagina) => {
    setPagina(pagina)
    toggleMenu();
  };

  // Manejar reproductor --------------
  const playRef = useRef(null);

  const [play, setPlay] = useState(false);

  const handleClick = () => {
    if (playRef.current) {
      playRef.current.playStop(); // Llamar a la función dentro de Head
    }
  };
  // ------------------------

  return (
    <div>
      {showGoUp && (
        <button className="go-up" onClick={goUp}>↑</button>
      )}

      <div className="menu-toggle">
        <button className="menu-icon" onClick={toggleMenu}>☰</button>
        <button className="menu-play" onClick={handleClick}>
          <img
            src={play ? "/icons/pause.svg" : "/icons/play.svg"}
            alt={play ? "Pause" : "Play"}
            width="24"
            height="24"
          />
        </button>
      </div>
      <div onClick={toggleMenu} className={`overlay ${isMenuActive ? "active" : ""}`}></div>
      <div className={`sidebar ${isMenuActive ? "active" : ""}`}>

        <div className="sidebar-header">
          <IconoCircular size="grande" ruta="/images/bn.jpg" />
          <h3 className="texto-mediano">Sergio Salgado</h3>
          <p className="cargo text-blue">Full Stack Developer</p>
          <CarruselHeader />
        </div>
        <hr />
        <nav className="sidebar-nav">
          <h3 className="nav-text-button" onClick={() => cambiaPagina("inicio")}>Presentación</h3>
          <h3 className="nav-text-button" onClick={() => cambiaPagina("trabajos")}>Proyectos</h3>
          <h3 className="nav-text-button" onClick={() => cambiaPagina("contacto")}>Contacto</h3>
        </nav>
        <hr />
        <div className="music">
          <p>¿Un poco de música?</p>
          <ReproductorMp3 ref={playRef} setPlay={setPlay} />
        </div>
      </div>
    </div>

  );
}
